<div class="rt-card" layout padding-right-small padding-tb-small>
  <div class="item-grabber" layout-centered>
    <rt-icon size="medium" name="drag-vertical" />
  </div>
  <div class="content">
    <div class="name-details">
      <span [class.archived-color]="isArchived" class="text">
        {{ location().name }}
      </span>
      @if (isArchived) {
        <span class="badge-wrapper">
          <rt-badge
            [text]="'app.locations.archived' | translate"
            color="secondary"
            [iconName]="'archive'"
            [rtTooltip]="translations.archiveBadgeTooltip | translate"
            [rtTooltipEnabled]="viewContext() === LocationsSectionViewContext.Job"
            margin-right-small-x
            margin-left-small-x
          />
        </span>
      }
      @if (isInvalid) {
        <span class="invalid badge-wrapper">
          <rt-icon
            [name]="'error-outline'"
            colorToken="colorIconCriticalDefault"
            margin-left-small-x
            margin-right-small-xx
          />
          {{ 'app.locations.invalid_address' | translate }}
        </span>
      }
    </div>
    <div margin-top-small-xxx [class.archived-color]="isArchived">
      {{ locationFullAddress }}
    </div>
  </div>
  @if (!readOnly()) {
    <rt-group>
      @if (hasManageLocationsAbility() && !this.isArchived) {
        <rt-icon-button (click)="onEdit()" iconName="edit" variant="plain" />
      }
      <div
        [rtTooltip]="'app.offer_form.job_location_section.unassign_location_tooltip' | translate"
      >
        <rt-icon-button (click)="onUnassign()" iconName="clear" variant="plain" />
      </div>
    </rt-group>
  }
</div>
